import { DropdownConfig } from '.';

export const DROPDOWN_CONFIGS: Record<string, DropdownConfig> = {
  datasource: {
    id: 'datasource-dropdown',
    placeholder: 'Select a data source...',
    searchPlaceholder: 'Type to search data sources...',
    shouldAutoFocusSearch: true,
  },
  answer: {
    id: 'answer-dropdown',
    placeholder: 'Select an answer...',
    searchPlaceholder: 'Type to search answers...',
    shouldAutoFocusSearch: true,
  },
  liveboard: {
    id: 'liveboard-dropdown',
    placeholder: 'Search and select a liveboard',
    searchPlaceholder: 'Type to search liveboards...',
    shouldAutoFocusSearch: true,
  },
  visualization: {
    id: 'visualization-dropdown',
    placeholder: 'Search and select a visualization',
    searchPlaceholder: 'Type to search visualizations...',
    shouldAutoFocusSearch: true,
  },
  fullapp: {
    id: 'fullapp-dropdown',
    placeholder: 'Select a full app...',
    shouldAutoFocusSearch: true,
  },
  'component-selection': {
    id: 'component-selection-dropdown',
    placeholder: 'Select a saved answer or data source...',
    shouldAutoFocusSearch: true,
  },
};

export const getDropdownConfig = (type: string, disabled?: boolean): DropdownConfig => {
  const config = DROPDOWN_CONFIGS[type];
  if (!config) {
    throw new Error(`Unknown dropdown type: ${type}`);
  }

  return {
    ...config,
    disabled,
    placeholder:
      type === 'visualization' && disabled ? 'Select a liveboard first' : config.placeholder,
  };
};
